

























































































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { BibliographySearchResultContentItem } from '@/api'
import {
  Col,
  ColItem,
  DataTable,
  DataTableHeader,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { SortOrder } from '@/types'

const COLS: Col[] = [
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '18',
    resizable: true,
    items: [
      {
        name: 'contentSortTitle',
        headerText: '内容タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '13',
    resizable: true,
    items: [
      {
        name: 'contentSortAuthor',
        headerText: '内容責任表示',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '24',
    resizable: true,
    items: [
      {
        name: 'sortTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '16',
    resizable: true,
    items: [
      {
        name: 'sortAuthor',
        headerText: '責任表示／年月日号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '16',
    resizable: true,
    items: [
      {
        name: 'sortPublisher',
        headerText: '出版者',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '13',
    resizable: true,
    items: [
      {
        name: 'sortPublished',
        headerText: '出版年',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller
  }
})
export default class BibliographySearchResultsContentTable extends DataTable {
  @Prop({
    type: Boolean
  })
  allSelect!: boolean

  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographySearchResultContentItem[]

  @Prop({
    type: Number,
    required: true
  })
  scrollTop!: number

  @Prop({
    type: Number,
    required: true
  })
  activeRowIndex!: number

  @Prop({
    type: String,
    required: true
  })
  sortName!: string

  @Prop({
    type: String,
    required: true
  })
  sortOrder!: SortOrder

  get showCols(): Col[] {
    return COLS
  }

  get rowHeight(): number {
    return 34
  }

  get tableRowClass(): any {
    return (index: number) => {
      return {
        odd: index % 2 === 1,
        even: index % 2 !== 1,
        active: index === this.activeRowIndex
      }
    }
  }

  // storeと密接に絡んでいるので扱いに注意すること
  @Watch('items')
  onChangeRoute(): void {
    if (this.items.length === 0) {
      this.onSort({
        name: '',
        order: ''
      })
    }
  }

  @Emit('click:title')
  onClickTitle(
    item: BibliographySearchResultContentItem
  ): BibliographySearchResultContentItem {
    return item
  }

  @Emit('scroll')
  onScroll(value: number): number {
    return value
  }

  @Emit('click:row')
  onClickRow(_index: number): number {
    return this.items.findIndex(item => item._index === _index)
  }

  @Emit('sort')
  onSort(sortColumn: SortColumn): ColItem | undefined {
    setSortOrder(this.showCols, sortColumn)
    return findSortColumnItem(this.showCols)
  }
}
